// src/components/Login.js
import React from 'react';
import { useAuth } from './AuthContext';
import './Login.css'; // Import the CSS file

function Login() {
    const { currentUser, signInWithGoogle } = useAuth();

    if (currentUser) {
        return <p>Welcome, {currentUser.email}!</p>;
    }

    return (
        <div className="login-container">
            <h1 className="login-header">Please Sign In</h1>
            <button className="login-button" onClick={signInWithGoogle}>Sign in with Google</button>
        </div>
    );
}

export default Login;